/**
 * @license
 * Powered by MaxDesign. All Rights Reserved.
 * ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
 * ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
 */

customElements.define(
  'footer-maxdesign',
  class Footer extends HTMLElement {
    constructor() {
      super();
      this.settings = JSON.parse(this.querySelector('[type="application/json"]').innerText);
      if (this.settings.accordeon) this.accordeonTabs();
      if (this.settings.klaviyo.enable) this.onKlaviyoSubmit();
    }

    accordeonTabs() {
      const tabs = this.querySelectorAll('.mdf-block__title');
      for (let tab of tabs) {
        tab.addEventListener('click', () => {
          tab.classList.toggle('active');
          if (tab.classList.contains('active')) this.slideDownAnimation(tab.nextElementSibling);
        });
      }
    }

    slideDownAnimation(content) {
      if (content) {
        content.style.height = 'auto';
        const height = content.offsetHeight + 'px';
        content.style.height = '0px';
        setTimeout(() => (content.style.height = height), 15);
      }
    }

    onKlaviyoSubmit() {
      this.newsletter = {
        form: this.querySelector('.mdf-newsletter'),
        input: this.querySelector('.mdf-newsletter input'),
        success: this.querySelector('.mdf-newsletter__success'),
        error: this.querySelector('.mdf-newsletter__error'),
      };
      this.newsletter.form.addEventListener('submit', e => {
        e.preventDefault();
        const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.settings.klaviyo.publicAPI}`;
        const options = {
          method: 'POST',
          headers: { revision: '2023-06-15', 'content-type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: this.settings.klaviyo.listId,
                custom_source: this.settings.klaviyo.source,
                email: this.newsletter.input.value,
              },
            },
          }),
        };
        fetch(endpoint, options).then(async response => {
          this.newsletter.success.hidden = !response.ok;
          this.newsletter.error.hidden = response.ok;
          if (!response.ok) {
            const error = await response.json();
            const errorMsg = error.errors[0].detail;
            if (errorMsg) this.newsletter.error.querySelector('[data-form-error]').textContent = errorMsg;
          }
        });
      });
    }
  }
);
